import React from 'react'
import {Skeleton} from '@chakra-ui/react'

const CustomerServiceSkeleton = () => {
    // TODO add a better matching skeleton
    return <Skeleton height="75vh" width="100%" />
}

export default CustomerServiceSkeleton
